import { render, staticRenderFns } from "./center-nav.vue?vue&type=template&id=4dab4c52&scoped=true&"
import script from "./center-nav.vue?vue&type=script&lang=js&"
export * from "./center-nav.vue?vue&type=script&lang=js&"
import style0 from "./center-nav.vue?vue&type=style&index=0&id=4dab4c52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dab4c52",
  null
  
)

export default component.exports